import defaultTheme from 'config/themes/default'
import React from 'react'

const GifIcon = ({ fill = defaultTheme.composerIconColor }) => (
  <svg width="23" height="16" viewBox="0 0 23 16">
    <path fill={fill} fillRule="nonzero" d="M7.92 11.13c-1.94 0-3.5-1.37-3.5-3.46 0-2.1 1.56-3.45 3.5-3.45 1.3 0 2.15.62 2.68 1.38l-.95.55c-.36-.5-.99-.89-1.73-.89-1.32 0-2.3 1-2.3 2.41 0 1.39.98 2.41 2.3 2.41.68 0 1.28-.31 1.58-.6V8.45h-2V7.42h3.16v2.49c-.65.73-1.59 1.22-2.74 1.22zm5.016-.13h-1.17V4.33h1.17V11zm2.475 0h-1.17V4.33h4.57v1.03h-3.4v1.72h3.33v1.03h-3.33V11zM3 0h17a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 1.3A1.7 1.7 0 0 0 1.3 3v10A1.7 1.7 0 0 0 3 14.7h17a1.7 1.7 0 0 0 1.7-1.7V3A1.7 1.7 0 0 0 20 1.3H3z"/>
  </svg>
)

export default GifIcon
